module.exports = __webpack_public_path__ + "img/app-sc-4.dcd7b0ca.png";